module.exports = __webpack_public_path__ + "static/media/blog_list2.20167d95.jpg";